export const SIGN_IN = 'SIGN_IN';
export const SIGN_OUT = 'SIGN_OUT';
export const SUPPLIER_SIGN_IN = 'SUPPLIER_SIGN_IN';
export const SUPPLIER_SIGN_OUT = 'SUPPLIER_SIGN_OUT';
